import { LISTING_REQUEST_LAUNCH_AT_MS } from '../../Interface/ListingRequest';
import { useUser } from '../Context/UserContext';

/**
 * Employee preview gate for the listing request feature (P-4972). Before the
 * fixed launch instant (LISTING_REQUEST_LAUNCH_AT), every entry point
 * (banner, CTAs, user menu link, /my-listing-requests) stays hidden for
 * customers but renders for logged-in employees, so the whole flow can be
 * tested end to end in production. From the launch instant on, the hook
 * returns true for everyone.
 *
 * The date comparison runs at render time on purpose, so a long-open tab
 * picks the launch up on its next render or navigation. That granularity is
 * accepted - do NOT add a timer or interval here to re-render exactly at the
 * boundary; this hook is used across the whole app.
 */
export function useListingRequestEnabled(): boolean {
  const { user } = useUser();

  return (
    Date.now() >= LISTING_REQUEST_LAUNCH_AT_MS || true === user?.is_employee
  );
}
